import type {
  CreateUpdatePriorityRequestDto,
  GetPrioritiesResponseDto,
  PriorityDto,
  RemovePriorityResponseDto,
} from 'shared/dtos/priorities.dto';

import { createAsyncThunk } from '@reduxjs/toolkit';
import PrioritiesService from 'services/priorities.service';

const prioritiesService = new PrioritiesService();

export const getPrioritiesThunk = createAsyncThunk<GetPrioritiesResponseDto>(
  'priorities/getPriorities',
  async (_, thunkAPI) => {
    try {
      return await prioritiesService.getPriorities();
    } catch (error) {
      return thunkAPI.rejectWithValue(error);
    }
  },
);

export const createPriorityThunk = createAsyncThunk<
  PriorityDto,
  CreateUpdatePriorityRequestDto
>('priorities/createPriority', async (payload, thunkAPI) => {
  try {
    const result = await prioritiesService.createPriority(payload);
    thunkAPI.dispatch(getPrioritiesThunk());
    return result;
  } catch (error) {
    return thunkAPI.rejectWithValue(error);
  }
});

export const removePriorityThunk = createAsyncThunk<
  RemovePriorityResponseDto,
  number
>('priorities/removePriority', async (id, thunkAPI) => {
  try {
    const result = await prioritiesService.removePriority(id);
    thunkAPI.dispatch(getPrioritiesThunk());
    return result;
  } catch (error) {
    return thunkAPI.rejectWithValue(error);
  }
});

export const updatePriorityThunk = createAsyncThunk<
  PriorityDto,
  CreateUpdatePriorityRequestDto & { id: number }
>('priorities/updatePriority', async (payload, thunkAPI) => {
  try {
    const { id, ...data } = payload;
    const result = await prioritiesService.updatePriority(id, data);
    thunkAPI.dispatch(getPrioritiesThunk());
    return result;
  } catch (error) {
    return thunkAPI.rejectWithValue(error);
  }
});
